// extracted by mini-css-extract-plugin
export var containerCategory = "index-module--containerCategory--uQwLh";
export var containerLeft = "index-module--containerLeft--7oC9b";
export var containerRight = "index-module--containerRight--ETQkQ";
export var containerSubtitle = "index-module--containerSubtitle--tfER7";
export var containerText = "index-module--containerText--SHMki";
export var serchContainer = "index-module--serchContainer--quZdF";
export var serchDiscription = "index-module--serchDiscription--rfSed";